var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sprite',{attrs:{"x":Math.floor(_vm.logoComponent.x),"y":Math.floor(_vm.logoComponent.y),"width":_vm.logoComponent.width,"height":_vm.logoComponent.height,"anchor":[ 0.5, 0.5 ],"angle":_vm.logoComponent.angle - 90,"src":"logo.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }